var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4453 2.16795C11.7812 1.94402 12.2188 1.94402 12.5547 2.16795L20.6641 8.57422C21.4987 9.13061 22 10.0673 22 11.0704V19C22 20.6569 20.6569 22 19 22H16C14.8954 22 14 21.1046 14 20V15.5C14 14.9477 13.5523 14.5 13 14.5H11C10.4477 14.5 10 14.9477 10 15.5V20C10 21.1046 9.10457 22 8 22H5C3.34315 22 2 20.6569 2 19V11.0704C2 10.0673 2.5013 9.13061 3.3359 8.57422L11.4453 2.16795ZM12 4.20185L4.4453 10.2383C4.1671 10.4238 4 10.736 4 11.0704V19C4 19.5523 4.44772 20 5 20H8V15.5C8 13.8431 9.34315 12.5 11 12.5H13C14.6569 12.5 16 13.8431 16 15.5V20H19C19.5523 20 20 19.5523 20 19V11.0704C20 10.736 19.8329 10.4238 19.5547 10.2383L12 4.20185Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBlack);
export default __webpack_public_path__ + "static/media/homeBlack.9997fa26007e4761bcc5553c2b6cdef0.svg";
export { ForwardRef as ReactComponent };